import React from 'react'
import { space } from '@entur/tokens'
import { Badge } from '@entur/layout'
import { SavingTicket } from '../../api-clients/api-types'

type RefundBadgeProps = {
  month: number
  ticket?: SavingTicket
}

export const RefundBadge: React.FC<RefundBadgeProps> = (props) => {
  const refundDate = props.ticket?.effectiveCancellationDate
  const isRefundedFromMonth = refundDate || (refundDate !== undefined && props.month === 0)

  if (!isRefundedFromMonth) return <></>

  return (
    <Badge
      data-cy="refund-badge"
      style={{ display: 'inline-block', marginRight: space.extraSmall }}
      variant="neutral"
    >
      Avbestilt
    </Badge>
  )
}
